import React from "react";
import { Typography } from "@mui/material";

const Attendance = ({ attendance }) => {
    return <Typography variant="body2">Attendance details</Typography>;
};

export default Attendance;
